var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"loading-screen loading-container\"><h1 data-i18n=\"common.loading\">Loading...</h1><div class=\"progress\"><div class=\"progress-bar\"></div></div><div class=\"errors\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/loading.jade
// module id = 791
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91